(function () {
  'use strict';
  function init(root) {
    if (root.dataset.evidenceReady) return;
    root.dataset.evidenceReady = 'true';
    var cards = Array.from(root.querySelectorAll('[data-pp-story]'));
    var filters = root.querySelector('[data-pp-story-filters]');
    var status = root.querySelector('[data-pp-story-status]');
    var more = root.querySelector('[data-pp-more-stories]');
    if (!cards.length || !filters || !status || !more) return;
    var selected = 'all', limit = Number(root.dataset.initialStories) || 3;
    function render() {
      var matched = cards.filter(function (card) { return selected === 'all' || card.dataset.ppStory.split(' ').includes(selected); });
      cards.forEach(function (card) { var i = matched.indexOf(card); card.hidden = i < 0 || i >= limit; });
      status.textContent = 'Showing ' + Math.min(limit, matched.length) + ' of ' + matched.length + ' stories.';
      more.hidden = limit >= matched.length;
      more.textContent = 'Show all ' + matched.length + ' stories';
      return matched;
    }
    filters.hidden = false; status.hidden = false;
    filters.querySelectorAll('button').forEach(function (button) {
      button.addEventListener('click', function () {
        selected = button.dataset.ppFilter; limit = Number(root.dataset.initialStories) || 3;
        filters.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
        render();
      });
    });
    more.addEventListener('click', function () { var previous = limit; limit = cards.length; var matched = render(); if (matched[previous]) matched[previous].focus(); });
    render();
  }
  document.querySelectorAll('[data-site-evidence]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-site-evidence]').forEach(init); });
})();
